import { useQuery } from '@tanstack/react-query';
import type { User } from '@/utils/types/User';
import { getUser } from './getUser';

export const useCurrentUser = () => {
  const {
    data: user,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['user'],
    queryFn: () => getUser(),
    staleTime: Infinity,
  });

  return {
    user: user as User,
    isLoading,
    isError,
  };
};
